//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../Features/Features.BodyFeature.js";
let d=[[[0,"IsOccurrence",0,0],[0,"JournalIdentifier",0,0],[0,"Name",0,0],[0,"OwningComponent",0,"Assemblies.Component",0],[0,"OwningPart",0,"BasePart",0],[0,"Prototype",0,"INXObject",0]],[[["numDiagnosticCodes","diagnosticCodes"],"GetFeatureDiagnostics",{},0,0],[[],"GetFeatureIconName",{R_:{iconName:''}},0,0],[[],"GetFeatureLayer",{R_:{layer:''}},0,0],[[],"GetFeatureObjectColor",{R_:{color:''}},0,0],[["numRefset","refSet"],"GetFeatureReferenceSets",{},0,0],[["numRefset","refSet"],"GetFeatureReferenceSetStrings",{},0,0],[["journal_identifier"],"FindObject",{R_:{found:"INXObject"}},1,0],[[],"Print",{},0,0],[["name"],"SetName",{},1,0]],[]];
SPLM.Weld.Transform = class extends SPLM.Features.BodyFeature{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.Transform";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;